import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

export interface IFRSQuestionExhibitDTO {
  id: string;
  title: string;
  type: string;
  filePath: string;
  exhibitData: Record<string, any[][]> | null;
}

export interface IFRSQuestionExhibitsMetaDTO {
  total: number;
  page: number;
  lastPage: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetIFRSQuestionExhibitsResponse {
  data: IFRSQuestionExhibitDTO[];
  meta: IFRSQuestionExhibitsMetaDTO;
}

interface GetIFRSQuestionExhibitsParams {
  page?: number;
  limit?: number;
  sort?: "asc" | "desc";
}

type GetIFRSQuestionExhibitsAPIResponse = {
  statusCode?: number;
  error?: null | ApiError;
  data?: GetIFRSQuestionExhibitsResponse;
};

export const GetIFRSQuestionExhibits = async (
  questionId: string,
  { page = 1, limit = 10, sort = "asc" }: GetIFRSQuestionExhibitsParams = {}
): Promise<GetIFRSQuestionExhibitsAPIResponse> => {
  try {
    const response = await axios.get(`/ifrs-question/${questionId}/exhibits`, {
      params: { page, limit, sort },
    });
    return { data: response.data.data };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
